import _toConsumableArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useState, useEffect, useCallback } from "react";
import { Events } from "services/adobeAnalytics";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSDivider } from "components/common/elsevier/Divider/Divider";
import { getSelectedDatabasesMasks, getAllDatabases, Databases } from "components/applogic/Databases";
import { arrayDelta } from "components/common/utils/ArrayUtils";
import useNotify from "services/notification";
import useDatabases from "components/fragments/Search/shared-components/Tabs/Databases/hook";
import ExploreContactButtons from "./ExploreContactButtons";
import AllDatabasesSwitch from "./AllDatabasesSwitch";
import DatabaseSwitch from "./DatabaseSwitch";
import Accordion from "./Accordion";
import Styles from "../Styles.module.scss";
function DrawerContent(_ref) {
  var validateDBSelection = _ref.validateDBSelection;
  var _useDatabases = useDatabases(),
    allDBValue = _useDatabases.allDBValue,
    availableDBs = _useDatabases.availableDBs,
    userMask = _useDatabases.userMask,
    isEntitled = _useDatabases.isEntitled,
    onUpdate = _useDatabases.onUpdate,
    _useDatabases$select = _slicedToArray(_useDatabases.select, 2),
    selected = _useDatabases$select[0],
    setSelected = _useDatabases$select[1],
    _useDatabases$all = _slicedToArray(_useDatabases.all, 2),
    allSelected = _useDatabases$all[0],
    setAllSelected = _useDatabases$all[1];
  var notify = useNotify();
  var _useState = useState([]),
    accordionDatabases = _useState[0],
    setAccordionDatabases = _useState[1];
  var _useState2 = useState(false),
    noDBError = _useState2[0],
    setNoDBError = _useState2[1];
  useEffect(function () {
    // Clean duplicate DBs for the accordion
    var dbs = arrayDelta(getAllDatabases(), availableDBs);
    dbs = dbs.filter(function (db) {
      return db.label !== "Compendex backfile" && db.label !== "Ei Backfile" && db.label !== "Inspec Archive" && db.searchcode !== "kna" && db.searchcode !== "ibf";
    });
    setAccordionDatabases(dbs);
  }, []);
  var handleToggle = useCallback(function (_ref2) {
    var value = _ref2.target.value;
    setNoDBError(false);
    var mask = Number(value);
    var selectedDBsMask = selected.reduce(function (sum, db) {
      return sum + db;
    }, 0);
    var dbName = Object.values(Databases).find(function (db) {
      return db.mask === Number(value);
    });

    // Update Modal Notification status
    if (selected.includes(mask)) {
      // Update local state
      setSelected(selected.filter(function (dbmask) {
        return dbmask !== mask;
      }));
      setAllSelected(false);
      if (selectedDBsMask - mask === 0) {
        setNoDBError(true);
        validateDBSelection(false);
      } else {
        validateDBSelection(true);
      }
      Events.startPage.applyDatabaseChanges();
      notify.info({
        text: "".concat(dbName.label, " is removed from your database selection.")
      });

      // Update Session Store
      onUpdate(selectedDBsMask - mask);
    } else {
      if (allDBValue === selectedDBsMask + mask) {
        setAllSelected(true);
      }
      // Update local state
      setSelected(function (prev) {
        return [].concat(_toConsumableArray(prev), [mask]);
      });
      validateDBSelection(true);
      // Update Session Store
      onUpdate(selectedDBsMask + mask);
      Events.startPage.applyDatabaseChanges();
      notify.info({
        text: "".concat(dbName.label, " is added to your database selection.")
      });
    }
  }, [selected, userMask]);
  var handleToggleAll = useCallback(function (_ref3) {
    var _ref3$target = _ref3.target,
      checked = _ref3$target.checked,
      value = _ref3$target.value;
    setNoDBError(false);

    // Update local state
    setSelected(checked ? getSelectedDatabasesMasks(value) : []);
    setAllSelected(checked);

    // Update Session Store
    checked ? onUpdate(value) : onUpdate(0);
    if (!checked) {
      setNoDBError(true);
      validateDBSelection(false);
      notify.info({
        text: "All databases are removed from your database selection."
      });
    } else {
      validateDBSelection(true);
      notify.info({
        text: "All databases are added to your database selection."
      });
    }
    Events.startPage.applyDatabaseChanges();
  }, [selected]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AllDatabasesSwitch, {
    availableDBs: availableDBs,
    allDBValue: allDBValue,
    noDBError: noDBError,
    allSelected: allSelected,
    handleToggleAll: handleToggleAll
  }), /*#__PURE__*/React.createElement(DatabaseSwitch, {
    availableDBs: availableDBs,
    isEntitled: isEntitled,
    noDBError: noDBError,
    selected: selected,
    handleToggle: handleToggle
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 0
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSDivider, {
    className: "".concat(Styles.bottomdivider)
  }))), accordionDatabases.length !== 0 && /*#__PURE__*/React.createElement(Accordion, {
    accordionDatabases: accordionDatabases
  }), /*#__PURE__*/React.createElement(ExploreContactButtons, null));
}
export default DrawerContent;